import React, { useEffect, useState } from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import { BRAND } from "../../lib/config";
import { Menu, X, ArrowUpRight } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // Close menu on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-[#070A0F]/90 backdrop-blur border-b border-white/10">
      <Container className="h-16 flex items-center justify-between">
        {/* Brand */}
        <a href="/" className="flex items-center gap-3">
          <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-white/[0.03]">
            <img
                            src="/branding/logo-white.png"
                            alt={`${BRAND.name} logo`}
                            className="h-auto w-auto"
                            loading="lazy"
                          />
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold text-white">{BRAND.name}</div>
            <div className="text-[11px] text-white/55">Speed without compromise</div>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-7 text-sm">
          <a className="text-white/70 hover:text-white transition" href={BRAND.gameHostingUrl}>
            Game Hosting
          </a>
          { /* <a className="text-white/70 hover:text-white transition" href={BRAND.dedicatedUrl}>
            Dedicated
          </a> */ }
          <a className="text-white/70 hover:text-white transition" href={BRAND.websitesUrl}>
            Websites
          </a>
          <a className="text-white/70 hover:text-white transition" href={BRAND.statusUrl}>
            Status
          </a>
          <a className="text-white/70 hover:text-white transition" href={BRAND.supportUrl}>
            Support
          </a>
        </nav>

        {/* Desktop actions */}
        <div className="hidden md:flex items-center gap-2">
          <Button href={BRAND.clientAreaUrl} variant="primary">
            Client Area
          </Button>
          <Button href={BRAND.gamePanelUrl} variant="secondary">
            Game Panel
          </Button>
        </div>

        {/* Mobile button */}
        <button
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-xl border border-white/10 bg-white/[0.03] text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </Container>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#070A0F]">
          <Container className="py-4">
            <div className="flex flex-col gap-3 text-sm">
              <a className="text-white/80 hover:text-white" href={BRAND.gameHostingUrl} onClick={() => setOpen(false)}>
                Game Hosting
              </a>
              { /*<a className="text-white/80 hover:text-white" href={BRAND.dedicatedUrl} onClick={() => setOpen(false)}>
                Dedicated
              </a> */ }
              <a className="text-white/80 hover:text-white" href={BRAND.websitesUrl} onClick={() => setOpen(false)}>
                Websites
              </a>
              <a className="text-white/80 hover:text-white" href={BRAND.statusUrl} onClick={() => setOpen(false)}>
                Status
              </a>
              <a className="text-white/80 hover:text-white" href={BRAND.supportUrl} onClick={() => setOpen(false)}>
                Support
              </a>

              <div className="pt-3 mt-2 border-t border-white/10 flex flex-col gap-3">
                <Button href={BRAND.clientAreaUrl} className="w-full" onClick={() => setOpen(false)}>
                  Client Area
                </Button>
                <Button href={BRAND.gamePanelUrl} className="w-full" onClick={() => setOpen(false)}>
                  Game Panel
                </Button>
              </div>
            </div>
          </Container>
        </div>
      )}
    </header>
  );
}
